import React from 'react'
import bannerImage from "./images/More.jpeg"

const More = () => {
  return (
        <div className="banner-image">
  <img src={bannerImage} alt="About Banner" className="banner-img" />
  
</div>
  )
}

export default More